import { createSelector } from 'reselect'
import { adaptSitesV4ToLegacySites } from 'lib/api/adapters/sites'

const selectSlice = state => state?.ssapiManager || {}

const selectUserSites = createSelector(
  [
    state => selectSlice(state).sites,
    state => selectSlice(state).isFetchingUserSites,
    state => selectSlice(state).error,
  ],
  (sites, isFetching, error) => {
    if (isFetching) return null
    if (error) return null

    return sites || null
  },
)

/**
 * Translation layer selector that provides sites from ssapiManager.sites
 * Adapts v4 sites to legacy format when needed for compatibility
 * This serves as the primary source for site data through indirection
 *
 * Sites stored in ssapiManager.sites are always in v4 format, so we always
 * adapt them to ensure proper legacy format including sitePreferences.highSchool
 */
const selectSitesFromSsapi = createSelector(
  [
    state => selectSlice(state).sites,
    state => selectSlice(state).isFetchingUserSites,
    state => selectSlice(state).error,
  ],
  (sites, isFetching, error) => {
    if (isFetching) return null
    if (error) return null
    if (!sites) return null

    // Sites from ssapiManager are always in v4 format, so always adapt them
    // to legacy format to ensure proper structure including sitePreferences.highSchool
    if (Array.isArray(sites)) {
      return adaptSitesV4ToLegacySites(sites)
    }

    return sites
  },
)

export default {
  selectUserSites,
  selectSitesFromSsapi,
}
